export default __webpack_public_path__ + "static/consultant-two-72362d76d59bbcc7b5d730de024cd267.png";